<template>
   <transition>
      <div class="default">
        <div v-for="item in pageObjectForSlug(this.$route.name)" v-if="$route.params.slugname">
          <div class="images" v-for="value in pageObjectForSlug(item.slug)" >
            <div v-for="object in value.children" v-if="$route.params.slugname === object.slug ">
              <div class="arrows">
                <router-link class="left" :to="{ path:'/'+object.prev }" v-if="object.prev">←</router-link>
                <router-link class="right" :to="{ path:'/'+object.next }" v-if="object.next">→</router-link>
              </div>
              <h2>{{ object.title }}</h2>
              <img v-lazy="object.image">
              <p>{{ object.year }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>


<script>
import { PageObject } from './../util/pageobject.js' 
const o = new PageObject() 

export default {
  name: 'detail',
   data () {
    return {
      localStorage: this.$store.state.jsonData
    }
  },
  methods:{
     pageObjectForSlug(sulgname){
      let res = o.pageObjectForSlugFromArray(sulgname,this.localStorage)
      return res;
    }

  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProjectDetail.vue